import { createContext } from 'react';

export const DesktopContext = createContext({
  desktop: false,
  desktopUser: {},
  desktppUserID: '',
  setDesktopUser: null,
  setDesktppUserID: null
});



// WEBPACK FOOTER //
// ./src/DesktopContext.js